import { VenuePayout } from 'apis/merchant-payout-service/types';
import { PAYOUTS_ISSUED_IN_2023_WITH_2022_INTERVAL } from 'modules/payout-reports/constants';

const isPayoutIssuedIn2023 = (payoutId: string) => {
  return PAYOUTS_ISSUED_IN_2023_WITH_2022_INTERVAL.includes(payoutId);
};

export const isMpsPayoutReport = (report: VenuePayout) => isPayoutIssuedIn2023(report.id) || report.isMpsPayout;
